module.exports = __webpack_public_path__ + "static/media/logo108.123e921a.png";